import * as React from 'react';
import clamp from 'lodash/clamp';

import {usePointerDrag} from 'src/hooks/usePointerDrag';


export default function ScrollContainer({
  className,
  style,
  contentWidth,
  contentHeight,
  validateDrag,
  scale,
  setScale,
  isScrollable = true,
  children,
}: {
  className?: string;
  style?: Record<any, any>;
  contentWidth: number;
  contentHeight: number;
  validateDrag: (arg1: React.SyntheticEvent) => unknown;
  scale: number;
  setScale: (arg1: number) => unknown;
  isScrollable?: unknown;
  children: React.ReactNode;
}) {
  /*
  React.useEffect(() => {
    const html = document.documentElement;
    if (html) {
    html.style.setProperty('overscroll-behavior-x', 'none');
     return () => {
      html.style.removeProperty('overscroll-behavior-x');
     };
    }
  }, []);
  */

  const [position, setPosition] = React.useState({x: 0, y: 0});

  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const scrollRef = React.useRef<HTMLElement | null | undefined>();
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const offsetRef = React.useRef<HTMLElement | null | undefined>();

  // NOTE (kyle): on first render, center the canvas.
  React.useLayoutEffect(() => {
    setPosition({
      ...position,
      x: Math.max(contentWidth - (scrollRef.current?.clientWidth || 0), 0) / 2,
    });
  }, []);

  // @ts-expect-error - TS7030 - Not all code paths return a value.
  React.useEffect(() => {
    const {current} = scrollRef;
    if (current && isScrollable) {
      const handleWheel = (event: WheelEvent) => {
        event.preventDefault();
        if (event.metaKey) {
          setScale(scale + event.deltaY * 0.01);
        } else {
          setClampedPosition(
            position.x + event.deltaX,
            position.y + event.deltaY,
          );
        }
      };

      //current.scrollLeft = (graphWidth - current.clientWidth) / 2;
      current.addEventListener('wheel', handleWheel, {passive: false});

      return () => {
        // @ts-expect-error - TS2769 - No overload matches this call.
        current.removeEventListener('wheel', handleWheel, {passive: false});
      };
    }
  }, [isScrollable, position, scale]);

  const setClampedPosition = (x: number, y: number) => {
    const scrollWidth = contentWidth - (scrollRef.current?.clientWidth || 0);
    const scrollHeight = contentHeight - (scrollRef.current?.clientHeight || 0);
    setPosition({
      x: clamp(x, 0, scrollWidth),
      y: clamp(y, 0, scrollHeight),
    });
  };

  const [dragProps] = usePointerDrag({
    validateDownEvent: (event) =>
      isScrollable &&
      (validateDrag(event) || event.target === scrollRef.current),
    onMove: ({deltaX, deltaY}) => {
      setClampedPosition(position.x - deltaX, position.y - deltaY);
    },
  });

  return (
    <div
      className={className}
      // @ts-expect-error - TS2322 - Type 'RefObject<HTMLElement | null | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
      ref={scrollRef}
      style={{...style, touchAction: 'none'}}
      {...dragProps}
    >
      <div
        // @ts-expect-error - TS2322 - Type 'RefObject<HTMLElement | null | undefined>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
        ref={offsetRef}
        style={{
          position: 'absolute',
          transform: `translate3d(${-position.x}px, ${-position.y}px, 0) scale(${scale})`,
          flex: '1 1 auto',
          flexFlow: 'column',
          minWidth: '100%',
          minHeight: '100%',
        }}
      >
        {children}
      </div>
    </div>
  );
}
